import React, { Component } from 'react'
import Style from './style.module.less'
import { observer } from 'mobx-react'
import moment from 'moment'

@observer
export default class extends Component {
  render() {
    const { store } = this.props
    const { onDateChange, showModalVisable, activeDate, isTeamSchedule } = store
    const isToday = moment().isSame(activeDate, 'day')

    return (
      <div className={Style.operation}>
        {!isToday && (
          <div
            className={`${Style.item} ${Style.today}`}
            onClick={() => onDateChange(moment())}
          />
        )}
        {!isTeamSchedule && (
          <div
            className={`${Style.item} ${Style.plus}`}
            onClick={showModalVisable()}
          />
        )}
      </div>
    )
  }
}
